<div class="card mb-4">
  <div class="card-header text-white">
    <h3>
      <i class="fas fa-id-card me-2"></i>
      Documentos
    </h3>
  </div>
  <div class="card-body">
    <p class="hint" *ngIf="lockedMessage">{{ lockedMessage }}</p>
    <p class="hint" *ngIf="!lockedMessage">PDF, JPG ou PNG. O envio substitui o arquivo anterior.</p>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">CNH</label>
        <div class="doc-actions">
          <a
            *ngIf="cnhDocumentUrl"
            [href]="cnhDocumentUrl"
            target="_blank"
            rel="noopener"
            class="btn btn-outline-primary">
            <i class="fas fa-external-link-alt me-2"></i>
            Visualizar
          </a>
          <span *ngIf="!cnhDocumentUrl" class="empty">Nenhum arquivo enviado</span>
          <ng-container *ngIf="canUpload && !lockedMessage">
            <label
              *appHasPermission="'B2BContracts.Edit'"
              class="btn btn-success mb-0"
              [class.disabled]="uploadingType === 'CNH'">
              <i class="fas fa-upload me-2"></i>
              {{ cnhDocumentUrl ? 'Substituir' : 'Enviar' }}
              <input
                type="file"
                [accept]="accept"
                hidden
                [disabled]="uploadingType === 'CNH'"
                (change)="onFileSelected($event, 'CNH')">
            </label>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label">Termo de responsabilidade</label>
        <div class="doc-actions">
          <a
            *ngIf="termoResponsabilidadeUrl"
            [href]="termoResponsabilidadeUrl"
            target="_blank"
            rel="noopener"
            class="btn btn-outline-primary">
            <i class="fas fa-external-link-alt me-2"></i>
            Visualizar
          </a>
          <span *ngIf="!termoResponsabilidadeUrl" class="empty">Nenhum arquivo enviado</span>
          <ng-container *ngIf="canUpload && !lockedMessage">
            <label
              *appHasPermission="'B2BContracts.Edit'"
              class="btn btn-success mb-0"
              [class.disabled]="uploadingType === 'TermoResponsabilidade'">
              <i class="fas fa-upload me-2"></i>
              {{ termoResponsabilidadeUrl ? 'Substituir' : 'Enviar' }}
              <input
                type="file"
                [accept]="accept"
                hidden
                [disabled]="uploadingType === 'TermoResponsabilidade'"
                (change)="onFileSelected($event, 'TermoResponsabilidade')">
            </label>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
